module.exports = __webpack_public_path__ + "img/OS0025.203d308.webp";